import dataLayer from './dataLayer'
import logger from './logger'
import root from './root'
import history from './history'
import { TRIGGER } from './eventTypes'

const triggerType = TRIGGER

/**
 * @function trigger Triggers a CustomEvent
 * @param  {String} type The type (triggerType) of event
 * @param  {String} name The name of the event
 */
const trigger = (type, name, skipHistory, params = {}) => {
  if (!Object.values(triggerType).includes(type)) {
    throw new TypeError(`Unknown trigger type "${type}".`)
  }

  dataLayer.set({ data: { event: name } })

  if (root.enabled) {
    window.dispatchEvent(new CustomEvent(type, { detail: { name, params } }))
  }

  if (!skipHistory) {
    history.push({ event: name, type, params })
  }

  logger.fired(name)
}

export default { trigger, triggerType }
